'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require('semantic-ui-react');

var _numeral = require('numeral');

var _numeral2 = _interopRequireDefault(_numeral);

var _formatting = require('../../utils/formatting');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AllTimeDataTable = function AllTimeDataTable(_ref) {
  var apiInfluencer = _ref.apiInfluencer,
      avgComments = _ref.avgComments,
      isYouTubeCompliance = _ref.isYouTubeCompliance;
  return _react2.default.createElement(
    _semanticUiReact.Table,
    { basic: 'very', fluid: true },
    _react2.default.createElement(
      _semanticUiReact.Table.Body,
      null,
      _react2.default.createElement(
        _semanticUiReact.Table.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          'videos'
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          (0, _formatting.commaFormatted)(apiInfluencer.aggregateYoutubeChannelStatistics.videoCount)
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          'subscribers'
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          (0, _formatting.commaFormatted)(apiInfluencer.aggregateYoutubeChannelStatistics.subscriberCount)
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          'views'
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          (0, _formatting.commaFormatted)(apiInfluencer.aggregateYoutubeChannelStatistics.viewCount)
        )
      ),
      !isYouTubeCompliance && _react2.default.createElement(
        _semanticUiReact.Table.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          'views per video'
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          (0, _formatting.commaFormatted)(apiInfluencer.aggregateYoutubeChannelStatistics.viewCount / apiInfluencer.aggregateYoutubeChannelStatistics.videoCount)
        )
      ),
      !isYouTubeCompliance && _react2.default.createElement(
        _semanticUiReact.Table.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          'comments per video'
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          (0, _formatting.commaFormatted)(avgComments)
        )
      ),
      !isYouTubeCompliance && _react2.default.createElement(
        _semanticUiReact.Table.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          'avg. daily viewing'
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          (0, _formatting.commaFormatted)(apiInfluencer.aggregateYoutubeChannelStatistics.averageDailyViews)
        )
      ),
      !isYouTubeCompliance && _react2.default.createElement(
        _semanticUiReact.Table.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          'avg. monthly viewing'
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          (0, _formatting.commaFormatted)(apiInfluencer.aggregateYoutubeChannelStatistics.averageMonthlyViews)
        )
      )
    )
  );
};

var LastThirtyDaysTable = function LastThirtyDaysTable(_ref2) {
  var thirtyDayData = _ref2.thirtyDayData,
      percentageChange = _ref2.percentageChange;
  return _react2.default.createElement(
    _semanticUiReact.Table,
    { basic: 'very', fluid: true },
    _react2.default.createElement(
      _semanticUiReact.Table.Body,
      null,
      _react2.default.createElement(
        _semanticUiReact.Table.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          '30 day trend'
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_semanticUiReact.Label, {
            basic: true,
            color: percentageChange > 0 ? 'green' : 'red',
            content: (0, _numeral2.default)(percentageChange).format('+0.0%')
          })
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          'videos'
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          (0, _formatting.commaFormatted)(thirtyDayData.videoChange)
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          'subscribers'
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_semanticUiReact.Label, {
            color: percentageChange > 0 ? 'green' : 'red',
            basic: true,
            content: '' + (percentageChange > 0 ? '+' : '') + (0, _formatting.commaFormatted)(thirtyDayData.subscriberChange)
          })
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          'views'
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          (0, _formatting.commaFormatted)(thirtyDayData.viewChange)
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          'avg. daily viewing'
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          (0, _formatting.commaFormatted)(thirtyDayData.viewChange / thirtyDayData.dayChange)
        )
      )
    )
  );
};

var YoutubeDataTabs = function YoutubeDataTabs(_ref3) {
  var percentageChange = _ref3.percentageChange,
      apiInfluencer = _ref3.apiInfluencer,
      avgComments = _ref3.avgComments,
      isYouTubeCompliance = _ref3.isYouTubeCompliance,
      thirtyDayData = _ref3.thirtyDayData;

  var panes = [{ menuItem: { content: 'Last 30 days', key: 'last30', icon: 'calendar alternate outline' },
    render: function render() {
      return _react2.default.createElement(LastThirtyDaysTable, {
        thirtyDayData: thirtyDayData,
        percentageChange: percentageChange
      });
    }
  }, { menuItem: { key: 'alltime', icon: 'history', content: 'All time' },
    render: function render() {
      return _react2.default.createElement(AllTimeDataTable, {
        apiInfluencer: apiInfluencer,
        avgComments: avgComments,
        isYouTubeCompliance: isYouTubeCompliance
      });
    }
  }];

  return _react2.default.createElement(_semanticUiReact.Tab, { panes: panes });
};

YoutubeDataTabs.propTypes = {
  percentageChange: _propTypes2.default.number.isRequired,
  apiInfluencer: _propTypes2.default.object.isRequired,
  avgComments: _propTypes2.default.number.isRequired,
  isYouTubeCompliance: _propTypes2.default.bool.isRequired,
  thirtyDayData: _propTypes2.default.object.isRequired
};

exports.default = YoutubeDataTabs;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/youtube-profile-data-large/youtube-data-tabs.js
 ** module id = 2599
 ** module chunks = 0
 **/